import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Div from "../../components/common/Div";
import Button from "../../components/common/Button";
import Image from "../../components/common/Image";
import { urlbase } from "../../constants/Constants";
import LogoutBox from "../Partials/LogoutBox";
import QuitTestBox from "../Partials/QuitTestBox";
import ArrowBackSharpIcon from "@mui/icons-material/ArrowBackSharp";
import { useLocation } from "react-router";
import ExitToAppIcon from "@mui/icons-material/PowerSettingsNewRounded";
import AccountCircleIcon from "@mui/icons-material/AccountCircleOutlined";
import BookIcon from "@mui/icons-material/FeedOutlined";
import InfoIcon from "@mui/icons-material/InfoOutlined";
import CancelIcon from "@mui/icons-material/CancelOutlined";
import Tooltip from '@mui/material/Tooltip';
import { s3BaseUrl } from "../../config/envConfig";
const transparent = "rgba(0,0,0,0)";
const iconDim = "35px";

export default function IconBar(props) {
  const history = useHistory();
  const [logout, setLogout] = useState(false);
  const [quitTest, setQuitTest] = useState(false);

  const user = props.user;
  const location = props.location;
  console.log(location);
  let test = undefined;
  if (props.test !== undefined) {
    test = props.test;
  }

  const height =
    location === "test"
      ? ""
      : location === "dashboard" || location === "testStart"
      ? "65px"
      : "55px";
  const titlePosition = location === "test" ? "column" : "row";
  const titlePresent = location === "dashboard" ? "none" : "flex";
  let title;
  if (location === "dictionary") {
    title = "";
  } else if (location === "profile" || location === "testStart") {
    title = "";
  } else if (location === "memo") {
    title = "";
  } else if (location === "solution") {
    title = "";
  } else if (location === "editQuestion") {
    title = "";
  } else {
    if (test === undefined) {
      title = "";
    } else {
      title = (
        <>
          {""}
          <span style={{ marginLeft: "10px" }}>{test.name}</span>
        </>
      );
    }
  }
  const homeLogoIsButton =
    location === "dictionary" ||
    location === "profile" ||
    location === "testStart" ||
    location === "memo" ||
    location === "solution";
  const xButton = location === "test" || location === "editQuestion";
  const language = location === "dictionary";
  const mainButtons = location === "dashboard";
  const bookButton = xButton;

  function LogoutHandler() {
    setLogout(true);
  }
  function LogoutCancelHandler() {
    setLogout(false);
  }
  function HomeLogoHandler() {
    history.push("/testdashboard", { user: user });
  }
  function QuitTestHandler() {
    setQuitTest(true);
  }
  function QuitTestCancelHandler() {
    setQuitTest(false);
  }

  async function InfoHandler() {
    let purl = await fetch(urlbase().concat("info_url"));
    let url = purl.text();
    window.open(await url);
  }

  function ProfileHandler() {
    history.push("/report", { user: user });
  }

  function BookHandler() {
    history.push("/dictionary", { user: user });
  }

  function HomeLogoIsButton(localLocation) {
    const history = useHistory();
    const location = useLocation();

    if (localLocation)
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "row",
            margin: "auto auto auto 0",
            maxWidth: "100%",
          }}
        >
          <Button
            backgroundColor="transparent"
            onClick={() => {
              if (
                location.pathname === "/report" ||
                location.pathname === "/history" ||
                location.pathname === "/profile" ||
                location.pathname === "/leaderboard"
              ) {
                history.push("/testdashboard", { user: user });
              } else {
                history.goBack();
              }
            }}
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "row",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ArrowBackSharpIcon
                sx={{ color: "white", fontSize: "30px", marginRight: "8px" }}
              />
              <span
                style={{
                  color: "#FBCD02",
                  fontSize: "1.2rem",
                  whiteSpace: "nowrap",
                  fontWeight: "bold",
                }}
              >
                Mobi
                <span style={{ color: "white" }}>Tutor</span>
                ZA
              </span>
            </div>
          </Button>
        </div>
      );
    else
      return (
        <Image
          src={s3BaseUrl + "/mobitutorza_logo_full.png"}
          alt="icon"
          width={"50px"}
          height={"50px"}
          style={{ marginLeft: "20px" }}
        />
      );
  }

  function BookButton(localLocation) {
    if (localLocation)
      return (
          <Tooltip title="Dictionary" arrow>
              <div>
                  <Button backgroundColor={transparent} onClick={BookHandler}>
                      <BookIcon sx={{ color: "white", fontSize: iconDim }} />
                  </Button>
              </div>
          </Tooltip>
      );
    else return <></>;
  }

  function getCloseButton(rand, XButtonArr) {
    return (
      <>
        <QuitTestBox
          display={XButtonArr[0]}
          handler={XButtonArr[2]}
          user={user}
        />

          <Tooltip title='Close'>
              <div>
                  <Button backgroundColor={transparent} onClick={XButtonArr[1]}>
                      <CancelIcon sx={{ color: "white", fontSize: iconDim }} />
                  </Button>
              </div>
          </Tooltip>
      </>
    );
  }

  function getLogoutButton(logoutArr) {
    return (
      <>
        <LogoutBox display={logoutArr[0]} handler={logoutArr[2]} />

          <Tooltip title='Logout'>
              <div>
                  <Button backgroundColor={transparent} onClick={logoutArr[1]}>
                      <ExitToAppIcon sx={{ color: "white", fontSize: iconDim }} />
                  </Button>
              </div>
          </Tooltip>
      </>
    );
  }

  function getDict() {
    return (
        <Tooltip title='Dictionary' arrow>
            <div>
                <Button backgroundColor={transparent} onClick={BookHandler}>
                    <BookIcon sx={{ color: "white", fontSize: iconDim }} />
                </Button>
            </div>
        </Tooltip>
    );
  }

  function getInfoButton() {
    return (
        <Tooltip title='Info' arrow>
            <div>
                <Button backgroundColor={transparent} onClick={InfoHandler}>
                    <InfoIcon sx={{ color: "white", fontSize: iconDim }} />
                </Button>
            </div>
        </Tooltip>
    );
  }

  function MainButtons(localLocation, logoutArr) {
    if (location === "testStart") {
      return (
        <div style={{ display: "flex" }}>
          {getInfoButton()}
          {getDict()}
          {getLogoutButton(logoutArr)}
        </div>
      );
    } else if (location === "test") {
      return (
        <div style={{ width: "100px",display:'flex' }}>
          {getDict()}
          {getCloseButton(xButton, [
            quitTest,
            QuitTestHandler,
            QuitTestCancelHandler,
          ])}
        </div>
      );
    } else if (location === "results") {
      return <div style={{ width: "0px" }}></div>;
    } else if (location === "profile") {
      return (
        <>
          {getInfoButton()}
          {getLogoutButton(logoutArr)}
        </>
      );
    } else if (location === "memo") {
      return <></>;
    } else if (location === "dictionary") {
      return (
          <>
              {getInfoButton()}
              {
                  <Tooltip title='Account' arrow>
                  <div>
                      <Button backgroundColor={transparent} onClick={ProfileHandler}>
                          <AccountCircleIcon sx={{ color: "white", fontSize: iconDim }} />
                      </Button>
                  </div>
              </Tooltip>
              }
              {getLogoutButton(logoutArr)}
          </>
      );
    }
    return (
      <>
          <Tooltip title="Info" arrow>
              <div>
                  <Button backgroundColor="transparent" onClick={InfoHandler}>
                      <InfoIcon sx={{ color: "white", fontSize: iconDim }} />
                  </Button>
              </div>
          </Tooltip>

        {BookButton(localLocation)}

          <Tooltip title='Account' arrow>
              <div>
                  <Button backgroundColor={transparent} onClick={ProfileHandler}>
                      <AccountCircleIcon sx={{ color: "white", fontSize: iconDim }} />
                  </Button>
              </div>
          </Tooltip>

        <LogoutBox display={logoutArr[0]} handler={logoutArr[2]} />

        <Tooltip title="Logout" arrow>
            <div>
                <Button backgroundColor={transparent} onClick={logoutArr[1]}>
                    <ExitToAppIcon sx={{ color: "white", fontSize: iconDim }} />
                </Button>
            </div>
        </Tooltip>

      </>
    );
  }

  return (
    <div
      style={{
        marginBottom: "10px",
        zIndex: 999,
        position: "relative",
        width: "100%",
      }}
    >
      <Div
        func="large, normal or small"
        height={height}
        width="100%"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Div func="spacing left" margin={"auto auto auto 0"} textAlign={"left"}>
          <Div func="title next to or underneath" flexDirection={titlePosition}>
            <Div func="button/not-button">
              {HomeLogoIsButton(homeLogoIsButton)}
            </Div>
            <Div
              func="title"
              display={titlePresent}
              color={"#FFFFFF"}
              style={{ marginLeft: "10px" }}
            >
              {title}
            </Div>
          </Div>
        </Div>
        {/* {location === "dictionary" && (
          <div
            style={{
              position: "absolute",
              left: "100%",
              transform: "translateX(100%)",
              fontSize: "1rem",
              color: "white",
              fontWeight: "bold",
              top: "15px",
            }}
          >
            Dictionary
          </div>
        )} */}
        <Div func="spacing right" margin={"auto 0 auto auto"} display='flex'>
          {MainButtons(mainButtons, [
            logout,
            LogoutHandler,
            LogoutCancelHandler,
          ])}
        </Div>
      </Div>
    </div>
  );
}
